import type { CardTemplateProps } from './index';

export default function CardTemplate({ id, classes, title, content, footer }: CardTemplateProps) @{
  <div id={id} class={classes} data-dls-component="Card">
    @if (title !== null) {
      <div class="card-header">{title}</div>
    }
    <div class="card-content">{content}</div>
    @if (footer !== null) {
      <div class="card-footer">{footer}</div>
    }
  </div>
}
